<template>
  <section id="chatManagement" class="chat-wrapper">
    <div v-if="isConfirm" class="chat-manage-message-overlay">
      <p>Are you sure you wish to leave this Chat Session ({{ confirmChannel.name }})?</p>
      <button class="btn btn-primary btn-sm" @click="leaveChannel">Leave</button>
      <button class="btn btn-primary btn-sm" @click="cancelLeaveChannel">Cancel</button>
    </div>
    <div class="chat-manage-header">
      <div class="row">
        <div class="col chat-manage-title">
          <span>Chat Session Management</span>
        </div>
        <div class="col-1">
          <div class="chat-close" @click="closeManagement">
            <i class="fas fa-times"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="row chat-manage-row mt-2">
      <div class="col chat-manage-channels">
        <table class="chat-manage-table table-bordered">
          <thead class="chat-manage-table-header bg-white sticky-top">
            <tr>
              <th>#</th>
              <th>last updated</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, idx) of channels" :key="idx">
              <td>{{ item.name }}</td>
              <td>{{ item.updated }}</td>
              <td>
                <button class="btn btn-link btn-sm" title="leave channel" @click="confirmLeaveChannel(item)">
                  leave
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <dt-message v-model="notice" :timeout="2000" class="alert alert-warning m-3" />
      </div>
    </div>
    <div class="row chat-manage-footer">
      <div class="col"></div>
      <div class="col-6 text-right"></div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import DtMessage from '@/components/utilities/form/dt-message'
import globals from '@/plugins/globals'
export default {
  name: 'chat-manage',
  components: {
    DtMessage
  },
  props: {
    channel: Object
  },
  data() {
    return {
      isLoading: false,
      notice: null,
      isConfirm: false,
      confirmChannel: null
    }
  },
  computed: {
    ...mapGetters('auth', ['profile']),
    ...mapGetters('chat', ['membership']),
    title() {
      let _data = null
      return _data
    },
    channels() {
      let _channels = []
      if (this.membership) {
        if (this.membership.data) {
          this.membership.data.forEach(element => {
            _channels.push({
              id: element.channel.id,
              name: element.channel.id.length < 10 ? element.channel.id : element.channel.name,
              updated: globals.formatDateTime(element.updated)
            })
          })
        }
      }
      return _channels
    }
  },
  methods: {
    ...mapActions('chat', ['removeChannelMembership', 'removeChannelMembers']),
    async init() {},
    closeManagement() {
      this.$emit('closeManagement')
    },
    cancelLeaveChannel() {
      this.isConfirm = false
    },
    confirmLeaveChannel(channel) {
      this.confirmChannel = channel
      this.isConfirm = true
    },
    async leaveChannel() {
      this.isConfirm = false
      console.log('Remove Membership', this.confirmChannel)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/chat/elements/chat-manage.vue